import React, { useEffect } from 'react';

import { Segmented } from 'antd';

import styled from 'styled-components';

import { useLayoutContext } from '@contexts/LayoutContext';

import CustomSwitch from '@components/Gui/CustomSwitch';
import FlexContainer from '@components/Gui/FlexContainer';
import { NwButton } from '@components/Gui/NwButton';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const CalendarFooterContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 2rem;

    .calendar-footer-left {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .calendar-footer-switch {
            font-size: ${(props) => props.theme.FontSizeSm};
            text-transform: uppercase;
            @media (max-width: 960px) {
                font-size: ${(props) => props.theme.FontSizeXSm};
            }
        }
    }

    .calendar-footer-right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
`;

const CalendarFooter = ({
    fixedFooter,
    type,
    previewMode,
    viewCalendar,
    filters,
    onSetFilters,
    onOpenSendAgendaDrawer,
    onOpenExportListDrawer,
    onChangeParams,
    isContactApproved,
}) => {
    const { breakpoints } = useLayoutContext();

    const handleToggleCancelled = (checked) => {
        onSetFilters({
            ...filters,
            hideCancelled: checked,
        });
    };

    const handleBilling = (value) => {
        const hideBilling = value === 'to-bill' ? true : false;
        onSetFilters({
            ...filters,
            hideBilling,
        });
    };

    const handleAcknowledgement = (value) => {
        onSetFilters({
            ...filters,
            filterAcknowledgement: value,
        });
    };

    const handleMine = (value) => {
        onSetFilters({
            ...filters,
            filterMine: value,
        });
    };

    const noLabel = breakpoints < 4 ? true : false;

    const getCalendarFooterContent = () => {
        return (
            <CalendarFooterContainer>
                {previewMode || !viewCalendar ? null : (
                    <>
                        <div className="calendar-footer-left">
                            <FlexContainer>
                                <CustomSwitch
                                    value={filters.hideCancelled}
                                    size="small"
                                    text="hide cancelled"
                                    onChange={handleToggleCancelled}
                                    className="calendar-footer-switch"
                                />
                                <Segmented
                                    style={{ marginLeft: '2rem' }}
                                    value={filters.filterAcknowledgement}
                                    onChange={handleAcknowledgement}
                                    size="small"
                                    options={[
                                        { label: 'all', value: 'all' },
                                        { label: 'checked', value: 'checked' },
                                        { label: 'to check', value: 'tocheck' },
                                    ]}
                                />
                                <Segmented
                                    style={{ marginLeft: '2rem' }}
                                    value={filters.filterMine}
                                    onChange={handleMine}
                                    size="small"
                                    options={[
                                        { label: 'all', value: 'all' },
                                        { label: 'mine only', value: 'mine' },
                                    ]}
                                />
                                <Segmented
                                    style={{ marginLeft: '2rem' }}
                                    value={filters.hideBilling ? 'to-bill' : 'all'}
                                    onChange={handleBilling}
                                    size="small"
                                    options={[
                                        { label: 'all', value: 'all' },
                                        { label: 'jobs to bill', value: 'to-bill' },
                                    ]}
                                />
                            </FlexContainer>
                        </div>
                        <div className="calendar-footer-right">
                            {type !== 'model' && (
                                <NwButton
                                    ghost
                                    icon={byPrefixAndName.fasl['filter-list']}
                                    size="small"
                                    label={noLabel ? null : 'change filters'}
                                    onClick={onChangeParams}
                                />
                            )}
                            {type === 'model' && (
                                <>
                                    <NwButton
                                        ghost
                                        icon={byPrefixAndName.fasl['share']}
                                        size="small"
                                        label={noLabel ? null : 'send agenda'}
                                        onClick={onOpenSendAgendaDrawer}
                                    />
                                    {onOpenExportListDrawer && (
                                        <NwButton
                                            ghost
                                            icon={byPrefixAndName.fasl['square-list']}
                                            size="small"
                                            label={noLabel ? null : 'export list'}
                                            onClick={onOpenExportListDrawer}
                                        />
                                    )}
                                </>
                            )}
                        </div>
                    </>
                )}
            </CalendarFooterContainer>
        );
    };

    if (fixedFooter) {
        return <div className="calendar-fixed-footer">{getCalendarFooterContent()}</div>;
    } else {
        return getCalendarFooterContent();
    }
};

export default CalendarFooter;
